//libs
import React, { memo } from 'react';

//styles
import { ColorsStrip, ColorOption, ColorText } from './styles';

//hooks
import { ColorOptionsProps } from './types';
import { getQuanityMessage, getColorName } from './helpers';

//constants
import { MAX_COLOR } from './constants';

const ColorOptions = ({ colors, className = '' }: ColorOptionsProps) => {
  if (colors?.length === 0) return null;

  const quantityMessage = getQuanityMessage(colors.length);
  return (
    <ColorsStrip className={className}>
      {colors.slice(0, MAX_COLOR).map((color: string) => (
        <ColorOption
          aria-label={getColorName(color)}
          data-test="color-option"
          key={color}
          color={color}
        />
      ))}

      {colors.length > MAX_COLOR && <ColorText data-test="more-text">{quantityMessage}</ColorText>}
    </ColorsStrip>
  );
};

export default memo(ColorOptions);
